import { useIntl } from 'react-intl'
import { SelectOption } from '../../components'
import { LocalizedOptions } from './types'

export const useLocalizedOptions = (): LocalizedOptions => {
  const { messages } = useIntl()

  const {
    // localizedBusinessLanguageOptions,
    localizedCountryOptions,
    localizedEmailTypeOptions,
    localizedExemptionReasonOptions,
    localizedLanguageOptions,
    localizedPostalCodeOptions
  } = messages

  return {
    // businessLanguageOptions: localizedBusinessLanguageOptions as SelectOption[],
    countryOptions: localizedCountryOptions as SelectOption[],
    emailTypeOptions: localizedEmailTypeOptions as SelectOption[],
    exemptionReasonOptions: localizedExemptionReasonOptions as SelectOption[],
    languageOptions: localizedLanguageOptions as SelectOption[],
    postalCodeOptions: localizedPostalCodeOptions as SelectOption[]
  }
}
